import { render, staticRenderFns } from "./138.vue?vue&type=template&id=6144f98b&scoped=true&"
var script = {}
import style0 from "./138.vue?vue&type=style&index=0&id=6144f98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144f98b",
  null
  
)

export default component.exports